import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pandaDoc = defineConnector({
  identifier: "pandaDoc",
  name: "PandaDoc",
  tagLine: "Document automation and e-signatures",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.pandadoc\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "API-Key",
      },
    ]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [PandaDoc](https://app.pandadoc.com/), go to **Settings → Integrations → API** and create an API key from the developer dashboard.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pandadoc.com/public/v1/documents",
  },
});
